import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./SiteNavbar.css";

export default function SiteNavbar() {
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const [eventsOpen, setEventsOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);

  const menuRef = useRef(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleOutsideClick = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setMenuOpen(false);
      setEventsOpen(false);
      setAboutOpen(false);
    }
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (menuOpen) document.addEventListener("mousedown", handleOutsideClick);
    else document.removeEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [menuOpen]);

  /* ✅ ACTIVE STATE CHECKS */
  const isAboutActive = location.pathname.startsWith("/about");
  const isEventsActive = location.pathname.startsWith("/events");

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top">
      <div className="container-fluid d-flex align-items-center">

        {/* Hamburger (Mobile) */}
        {isMobile && (
          <button className="navbar-toggler me-2" onClick={toggleMenu}>
            <span className="navbar-toggler-icon"></span>
          </button>
        )}

        {/* Logo */}
        <NavLink to="/" className="navbar-brand d-flex align-items-center mb-0">
          <img src="/logo.png" alt="Logo" className="logo-img me-2" />
          <div className="logo-text">
            <h5 className="mb-0 fw-bold">The Gifted Child</h5>
            <small className="text-muted">Pediatric Therapy Centre</small>
          </div>
        </NavLink>

        {/* ================= DESKTOP MENU ================= */}
        {!isMobile && (
          <div className="desktop-menu">
            <ul className="navbar-nav mb-2 mb-lg-0">

              <li className="nav-item">
                <NavLink to="/" className="nav-link">Home</NavLink>
              </li>

              {/* ABOUT */}
              <li
                className="nav-item dropdown"
                onMouseEnter={() => setAboutOpen(true)}
                onMouseLeave={() => setAboutOpen(false)}
              >
                <span className={`nav-link dropdown-toggle ${isAboutActive ? "active" : ""}`}>
                  About
                </span>

                {aboutOpen && (
                  <ul className="dropdown-menu show shadow">
                    <li><NavLink to="/about" end className="dropdown-item">About Us</NavLink></li>
                    <li><NavLink to="/about/advanced-physiotherapy" className="dropdown-item">Advanced Physiotherapy</NavLink></li>
                    <li><NavLink to="/about/team" className="dropdown-item">Team</NavLink></li>
                  </ul>
                )}
              </li>

              <li className="nav-item">
                <NavLink to="/services" className="nav-link">Services</NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/gallery" className="nav-link">Gallery</NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/testimonials" className="nav-link">Testimonials</NavLink>
              </li>

              {/* EVENTS */}
              <li
                className="nav-item dropdown"
                onMouseEnter={() => setEventsOpen(true)}
                onMouseLeave={() => setEventsOpen(false)}
              >
                <span className={`nav-link dropdown-toggle ${isEventsActive ? "active" : ""}`}>
                  Events
                </span>

                {eventsOpen && (
                  <ul className="dropdown-menu show shadow">
                    <li>
                      <NavLink to="/events/christmas" end className="dropdown-item">
                        Christmas Celebration
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/events/republic-day" className="dropdown-item">
                          Republic Day Celebration
                      </NavLink>
                    </li>
                  </ul>
                )}
              </li>

              <li className="nav-item">
                <NavLink to="/contact" className="nav-link">Contact</NavLink>
              </li>

            </ul>
          </div>
        )}

        {/* ================= MOBILE MENU ================= */}
        {isMobile && (
          <div ref={menuRef} className={`mobile-menu ${menuOpen ? "show" : ""}`}>
            <ul className="navbar-nav">

              <li className="nav-item">
                <NavLink to="/" className="nav-link" onClick={() => setMenuOpen(false)}>Home</NavLink>
              </li>

              {/* ABOUT (Mobile) */}
              <li className="nav-item">
                <span
                  className={`nav-link ${isAboutActive ? "active" : ""}`}
                  onClick={() => setAboutOpen(!aboutOpen)}
                >
                  About ▾
                </span>

                {aboutOpen && (
                  <ul className="ps-3">
                    <li><NavLink to="/about" end className="nav-link" onClick={() => setMenuOpen(false)}>About Us</NavLink></li>
                    <li><NavLink to="/about/advanced-physiotherapy" className="nav-link" onClick={() => setMenuOpen(false)}>Advanced Physiotherapy</NavLink></li>
                    <li><NavLink to="/about/team" className="nav-link" onClick={() => setMenuOpen(false)}>Our Team</NavLink></li>
                  </ul>
                )}
              </li>

              <li className="nav-item">
                <NavLink to="/services" className="nav-link" onClick={() => setMenuOpen(false)}>Services</NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/gallery" className="nav-link" onClick={() => setMenuOpen(false)}>Gallery</NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/testimonials" className="nav-link" onClick={() => setMenuOpen(false)}>Testimonials</NavLink>
              </li>

              {/* EVENTS (Mobile) */}
              <li className="nav-item">
                <span
                  className={`nav-link ${isEventsActive ? "active" : ""}`}
                  onClick={() => setEventsOpen(!eventsOpen)}
                >
                  Events ▾
                </span>

                {eventsOpen && (
                  <ul className="ps-3">
                    <li>
                      <NavLink to="/events/christmas" end className="nav-link" onClick={() => setMenuOpen(false)}>
                         Christmas Celebration
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/events/republic-day" className="nav-link" onClick={() => setMenuOpen(false)}>
                         Republic Day Celebration
                      </NavLink>
                    </li>
                  </ul>
                )}
              </li>

              <li className="nav-item">
                <NavLink to="/contact" className="nav-link" onClick={() => setMenuOpen(false)}>Contact</NavLink>
              </li>

            </ul>
          </div>
        )}
      </div>
    </nav>
  );
}
